import React, { Component } from 'react'
// import { hot } from 'react-hot-loader/root';
import {
  HashRouter as Router,
  Route,
  Switch,
  withRouter,
} from 'react-router-dom'
import { getRouterData } from './web'
import _ from 'lodash'
import { notification, Modal, message } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import qs from 'query-string'
import { API_HOST } from '../configs/env'
import whttp from '../libs/whttp'
import './styles.module.scss'
import AppHelper from '../libs/AppHelper'
import history from '../libs/history'
import NotificationCenter, {
  NotificationName,
} from '../libs/NotificationCenter'
import { wConnectRedux } from '../reducers'
import { LOGIN_LINK, LOGIN_ECLINK } from '../configs/env'
import { __ } from '@wordpress/i18n'

const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL')
const INDEX_URL = _.get(window, 'VC_CONFIG.INDEX_URL')

//const _ = __
class ECLogin extends Component {
  state = {
    LoginUrl: null,
  }
  componentDidMount() {
    const { auth, user } = this.props

    if (auth && auth.isLogin) {
      this.getProfile()
    }
  }

  componentWillUnmount() {
    //NotificationCenter.default.removeObserver(this)
  }

  getProfile = () => {
    this.setState({ isSubmitData: true, messages: {} })

    whttp.get(API_HOST + `/api/account/cc/getProfile`, {}, (state, res) => {
      this.setState({ isSubmitData: false })

      const { code = 100, reason = '發生錯誤', data = {} } = res

      if (state === false) {
        return message.error('發生錯誤')
      }

      if (code !== 200) {
        // notification['error']({
        //   message: '資料讀取失敗',
        //   description: reason,
        // });

        return this.setState({ messages: data.messages || {} })
      }
      this.setState({ info: data })
      //console.log('getProfile',data)
    })
  }

  render() {
    const { auth } = this.props
    const user = _.get(this, 'props.user')
    const roles = _.get(this, 'props.user.roles', [])

    // 此處可簡單處理轉導功能
    // if (user.isLogin === false && window.location.pathname !== '/')
    //   history.replace('/')
    //console.log(user);
    const search = _.get(window, 'location.search')

    const queryParams = qs.parse(search)
    const slug = _.get(queryParams, 'page')
    const { Logoutconfirm } = Modal
    const ProfileInfo = _.get(this, 'state.info')
    const src_token = _.get(ProfileInfo, 'access_token')
    const src_client_id = _.get(ProfileInfo, 'client_id')

    // 此處不使用Route原本Path的功能
    // 改看wp-admin/admin.php?page=stores
    return (
      <div>
        {auth && auth.isLogin && src_token && src_client_id ? (
          <a
            class='nav-link'
            role='button'
            // href={`${LOGIN_ECLINK}?src_client_id=${src_client_id}&src_token=${src_token}`}
            href='http://online.uni-prosperity.com.tw/zh/homepage/?utm_source=web&utm_medium=button'
            rel='noopener noreferrer'
            target='_blank'>
            <span class='iconBox'>
              <img
                src={`${PLUGIN_ASSETS_URL}img/header/topbag.svg`}
                alt=''
              />
            </span>
            {__('線上購物', 'cec-plugin-stores')}
          </a>
        ) : (
          <a
            class='nav-link'
            role='button'
            href='http://online.uni-prosperity.com.tw/zh/homepage/?utm_source=web&utm_medium=button'
            rel='noopener noreferrer'
            target='_blank'>
            <span class='iconBox'>
              <img
                src={`${PLUGIN_ASSETS_URL}img/header/topbag.svg`}
                alt=''
              />
            </span>
            {__('線上購物', 'cec-plugin-stores')}
          </a>
        )}
      </div>
    )
  }
}

export default wConnectRedux(ECLogin)

// export default process.env.NODE_ENV === "development" ? hot(wConnectRedux(App)) : wConnectRedux(App)



// WEBPACK FOOTER //
// ./src/routes/ECLogin.js